import { Component, ViewEncapsulation, OnInit, inject } from '@angular/core';
import { RoleService } from '@app/core/services/role/role.service';

@Component({
    selector: 'app-private',
    templateUrl: './private.component.html',
    styleUrls: ['./private.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PrivateComponent  implements OnInit{
  roleService = inject(RoleService);


  ngOnInit(): void {   
   this.roleService.isQuickapi();   
  }
}
